/* oxlint-disable typescript/no-unnecessary-condition -- migration untrusted data */
// Migration: v5 → v6
// Radio and checkbox widgets gained noteSettings array derived from canNoteOptionIds.

import type { MigratableTemplateContent } from './types';

export const migrateV5ToV6 = (data: MigratableTemplateContent): void => {
  const widgets = data.widgets;

  if (widgets && typeof widgets === 'object') {
    for (const widget of Object.values(widgets)) {
      if (widget.type !== 'radio' && widget.type !== 'checkbox') continue;

      const canNoteOptionIds = (widget as Record<string, unknown>)
        .canNoteOptionIds;

      if (!Array.isArray(canNoteOptionIds)) {
        (widget as Record<string, unknown>).noteSettings = [];
        continue;
      }

      (widget as Record<string, unknown>).noteSettings = canNoteOptionIds.map(
        (optionId) => ({
          optionId: String(optionId),
          required: false,
          width: 'md',
        }),
      );
    }
  }

  data.version = '6';
};
